import BaseRouter from './pages/BaseRouter';

function App() {
  return (
    <div className="App">
      <BaseRouter />
    </div>
  );
}

export default App;
